import { render, staticRenderFns } from "./DeliveryManagement.vue?vue&type=template&id=046842c2&scoped=true"
import script from "./DeliveryManagement.vue?vue&type=script&lang=js"
export * from "./DeliveryManagement.vue?vue&type=script&lang=js"
import style0 from "./DeliveryManagement.vue?vue&type=style&index=0&id=046842c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046842c2",
  null
  
)

export default component.exports